import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/page/Login";
import Index from "@/components/dashboard/Index";
Vue.use(Router);
const router = new Router({
  mode: "history",
  base: "/ess",
  meta: {
    // when set true, the route will not be cached by <keep-alive> (default false)
    noCache: true,
  },
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/role",
      name: "RolePage",
      component: () => import("@/components/page/RolePage"),
    },
    {
      path: "/index",
      name: "indexx",
      component: Index,
    },
    {
      path: "/profile",
      name: "Profile",
      component: () => import("@/components/profile/Profile"),
    },
    {
      path: "/contract",
      name: "contract",
      component: () => import("@/components/contract/contract"),
    },
    {
      path: "/salaryslip",
      name: "SalarySlip",
      component: () => import("@/components/salaryslip/SalarySlip"),
    },
    {
      path: "/leaverequest",
      name: "LeaveRequest",
      component: () => import("@/components/leaverequest/LeaveRequest"),
    },
    {
      path: "/assetregister",
      name: "AssetRegister",
      component: () => import("@/components/view/AssetRegister"),
    },
    {
      path: "/colleaguedirectory",
      name: "ColleagueDirectory",
      component: () => import("@/components/view/ColleagueDirectory"),
    },
    {
      path: "/companydocuments",
      name: "CompanyDocuments",
      component: () => import("@/components/view/CompanyDocuments"),
    },
    {
      path: "/companypolicy",
      name: "CompanyPolicy",
      component: () => import("@/components/view/CompanyPolicy"),
    },
    {
      path: "/onboardingmanual",
      name: "OnBoardingManual",
      component: () => import("@/components/view/OnBoardingManual"),
    },
    {
      path: "/organizationchart",
      name: "OrganizationChart",
      component: () => import("@/components/view/OrganizationChart"),
    },
    {
      path: "/vesselinfo",
      name: "VesselInfo",
      component: () => import("@/components/view/VesselInfo"),
    },
    {
      path: "/changepassword",
      name: "ChangePassword",
      component: () => import("@/components/page/ChangePassword"),
    },
    {
      path: "/documentrequest",
      name: "DocumentRequest",
      component: () => import("@/components/documentrequest/DocumentRequest"),
    },
    {
      path: "/leaveapprove",
      name: "LeaveApproval",
      component: () => import("@/components/leaveApproval/LeaveApproval"),
    },
    {
      path: "/attendance",
      name: "Attendance",
      component: () => import("@/components/view/Attendance"),
    },
    {
      path: "/applicantform/:m",
      name: "ApplicantForm",
      component: () => import("@/components/ApplicantForm/ApplicantForm"),
    },
    {
      path: "/handbook",
      name: "HandBook",
      component: () => import("@/components/profile/HandBook"),
    },
    {
      path: "/handbook",
      name: "HandBook",
      component: () => import("@/components/profile/HandBook"),
    },
    {
      path: "/approvedregister",
      name: "ApprovedLeaveRegisters",
      component: () =>
        import("@/components/leaveApproval/ApprovedLeaveRegisters"),
    },
    {
      path: "/leavecalendar",
      name: "LeaveCalender",
      component: () => import("@/components/LeaveCalendar/LeaveCalendar"),
    },
  ],
  linkActiveClass: "active",
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js